import { useAppTranslation } from '../../hooks'

interface Error {
  code: string
}

export const GraphErrorList = ({ errors }: { errors: any }) => {
  const { label } = useAppTranslation()

  return (
    <ul>
      {errors.map((e, i) => (
        <li key={i}>
          {label(e.extensions?.code as string)} {label(e?.message)}
        </li>
      ))}
    </ul>
  )
}
